import "./Login.scss";

import {
  Container,
  Grid,
  isWidthDown,
  LinearProgress,
  Typography,
  withWidth,
} from "@material-ui/core";
import { ApiErrors } from "common/backend/api-errors/errors";
import { CommonButton, UserInfoField } from "common/components";
import { CommonErrorDialog } from "common/components/CommonErrorDialog";
import { LoginUser } from "common/graphql/queryDescriptors";
import { useCustomQuery } from "common/store/hooks/useCustomQuery";
import { LoginUserManageable } from "common/store/user/types";
import { errorMessages } from "common/utils/validation";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

function Login({ width }: any) {
  // State
  const [error, setError] = useState("");

  // Hooks
  const history = useHistory();
  const { t } = useTranslation();

  const { execute: login } = useCustomQuery(LoginUser({
    onSuccess: () => {
      history.push("/landing");
    },
    onError: (error: ApiErrors) => {
      if (error === ApiErrors.USER_INVALID_CREDENTIALS) {
        setError(t("Wrong email or password"));
      }
    },
  }));

  // Options
  const initialValues = new LoginUserManageable();

  // Validation
  const onValidate = (values: LoginUserManageable) => {
    return new LoginUserManageable(values).validate(
      Object.keys(values),
      errorMessages
    );
  };

  const onSubmit = async (values: LoginUserManageable) => {
    await login({ variables: { input: new LoginUserManageable(values).serialize() } });
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validate={onValidate}
        onSubmit={onSubmit}
      >
        {({
          submitForm,
          isSubmitting,
          setFieldValue,
          values,
          errors,
          touched,
        }) => {
          const props = {
            values,
            errors,
            touched,
            setFieldValue,
            disableImmutable: false,
          };

          return (
            <Form className="login">
              <Container
                className={
                  isWidthDown(
                    "xs",
                    width
                  ) ? "container--mobile" : "container"
                }
              >
                <Grid container spacing={6}>
                  <Grid item xs={12}>
                    <Typography className="title" color="primary">
                      {t("Log in")}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <UserInfoField id="email" {...props} />
                  </Grid>

                  <Grid item xs={12}>
                    <UserInfoField id="password" {...props} />
                  </Grid>

                  <Grid item xs={6}>
                    {isSubmitting ?
                      <LinearProgress />
                      :
                      <CommonButton
                        onClick={submitForm}
                        isSubmitting={isSubmitting}
                        values={values}
                        errors={errors}
                        touched={touched}
                        text={t("Log in")}
                      />
                    }
                  </Grid>
                </Grid>
              </Container>
            </Form>
          );
        }}
      </Formik>

      <CommonErrorDialog error={error} setError={setError} />
    </>
  );
}

export default withWidth()(Login);